module.exports = __webpack_public_path__ + "img/doctor-shift-icon.e81223e7.svg";